/**
 * Hairmosa — avis (accueil).
 * Curseur sous le rail : une puce par avis, cliquable, qui suit le défilement.
 * Les cartes s'alignent en "start" (scroll-snap-align: start) : la puce active est
 * celle de la carte la plus proche du bord gauche du rail, pas du centre.
 * Aucune librairie.
 */
(function () {
  if (!window.customElements || window.customElements.get('hm-avis-accueil')) {
    return;
  }

  function closestCardIndex(rail, cards) {
    var axis = rail.getBoundingClientRect().left + 20;
    var closest = 0;
    var distance = Infinity;

    cards.forEach(function (card, index) {
      var d = Math.abs(card.getBoundingClientRect().left - axis);
      if (d < distance) {
        distance = d;
        closest = index;
      }
    });

    return closest;
  }

  class HmAvisAccueil extends HTMLElement {
    connectedCallback() {
      this._rail = this.querySelector('.hm-avis-accueil__rail');
      this._cards = [].slice.call(this.querySelectorAll('.hm-avis-carte'));
      this._dots = [].slice.call(this.querySelectorAll('.hm-curseur button'));
      this._current = -1;

      this._onScroll = this._onScroll.bind(this);

      this._dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          var card = this._cards[index];
          if (this._rail && card) {
            this._rail.scrollTo({ left: card.offsetLeft - this._rail.offsetLeft, behavior: 'smooth' });
          }
        }.bind(this));
      }, this);

      if (this._rail && this._cards.length && this._dots.length) {
        this._rail.addEventListener('scroll', this._onScroll, { passive: true });
        this._followScroll();
      }
    }

    disconnectedCallback() {
      if (this._rail) {
        this._rail.removeEventListener('scroll', this._onScroll);
      }
    }

    _followScroll() {
      var index = closestCardIndex(this._rail, this._cards);
      if (index === this._current) {
        return;
      }
      this._current = index;

      this._dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    _onScroll() {
      this._followScroll();
    }
  }

  window.customElements.define('hm-avis-accueil', HmAvisAccueil);
})();
